// Vue
import {Vue, Component, Prop, Watch} from 'vue-property-decorator'

// Template
import template from './template.vue'

// Components
import {Col} from '../col/Col'
import {Row} from '../row/Row'
import {Icon} from '../icon/Icon'
import {FilterItem} from './filter_item/FilterItem'

// Components
@Component({
    name: 'FilterBox',
    components: {
        Col,
        Row,
        Icon,
        FilterItem
    },
    mixins: [
        template,
    ]
})
export class FilterBox extends Vue {

    private isExpanded: boolean = false

    public get hasExtendedClass() {
        if ( !this.hasExtendedFilters )
        {
            return ``
        }
        return `${this.$appPrefix}-filterbox--toggleable`
    }

    public get showExtendedClass() {
        if ( !this.hasExtendedFilters )
        {
            return ``
        }
        return `${this.$appPrefix}-filterbox--${this.isExpanded ? 'extended' : 'simple'}`
    }

    @Prop({default: 'inverted'})
    public theme!: string

    @Prop({default: false})
    public hasExtendedFilters!: boolean

    @Prop()
    public value!: boolean

    @Watch('value')
    public watchValue(value, oldValue) {

        if (value != this.isExpanded) {
            this.isExpanded = value
        }
    }

    public created() {

        if (this.value != this.isExpanded) {
            this.isExpanded = this.value
        }
    }

    public toggle(e: Event) {

        // value true = open, false = closed
        if (this.isExpanded) {
            this.isExpanded = false
            this.$emit('input', false)
            this.$emit('close')
        } else {
            this.isExpanded = true
            this.$emit('input', true)
            this.$emit('open')
        }

    }
}